(function () {
  function initZebaeshFaq() {
    /* Not relying on .zbc-help-center — Shopify's Policies editor can strip
       class attributes from outer wrapper tags. Search the whole document
       for the groups container instead, which survives because it's nested. */
    var groupsWrap = document.querySelector('.zbc-faq-groups');
    if (!groupsWrap) return;

    var groups = Array.prototype.slice.call(groupsWrap.querySelectorAll('.zbc-faq-group'));
    if (!groups.length) return;

    /* Start fully closed */
    groups.forEach(function (group) {
      group.classList.remove('is-open');
      group.querySelectorAll('.zbc-faq-item').forEach(function (item) {
        item.classList.remove('is-open');
      });
    });

    /* ONE listener on the whole groups container handles everything */
    groupsWrap.addEventListener('click', function (event) {

      var head = event.target.closest('.zbc-faq-group-head');
      if (head) {
        var group = head.closest('.zbc-faq-group');
        if (!group) return;

        var willOpen = !group.classList.contains('is-open');

        groups.forEach(function (g) {
          var open = willOpen && g === group;
          g.classList.toggle('is-open', open);
          if (!open) {
            g.querySelectorAll('.zbc-faq-item').forEach(function (item) {
              item.classList.remove('is-open');
            });
          }
        });

        if (willOpen) {
          window.setTimeout(function () {
            group.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }, 80);
        }
        return;
      }

      var question = event.target.closest('.zbc-faq-question');
      if (question) {
        var item = question.closest('.zbc-faq-item');
        if (!item) return;
        var parentGroup = item.closest('.zbc-faq-group');
        if (!parentGroup) return;

        var willOpenQ = !item.classList.contains('is-open');

        parentGroup.querySelectorAll('.zbc-faq-item').forEach(function (otherItem) {
          otherItem.classList.remove('is-open');
        });

        if (willOpenQ) {
          item.classList.add('is-open');
        }
        return;
      }
    });

    /* Keyboard support (Enter / Space) */
    groupsWrap.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      var target = event.target.closest('.zbc-faq-group-head, .zbc-faq-question');
      if (!target) return;
      event.preventDefault();
      target.click();
    });

    /* Make headers/questions keyboard-focusable */
    groups.forEach(function (group) {
      var head = group.querySelector('.zbc-faq-group-head');
      if (head) {
        head.setAttribute('role', 'button');
        head.setAttribute('tabindex', '0');
        head.style.cursor = 'pointer';
      }
      group.querySelectorAll('.zbc-faq-question').forEach(function (q) {
        q.setAttribute('role', 'button');
        q.setAttribute('tabindex', '0');
        q.style.cursor = 'pointer';
      });
    });

    /* Top help cards jump to + open category (works whether or not
       .zbc-help-center wrapper class survived) */
    var categoryMap = {
      '#order-faqs': 'order-faqs',
      '#shipping-faqs': 'shipping-faqs',
      '#returns-faqs': 'returns-faqs',
      '#payment-faqs': 'payment-faqs',
      '#product-faqs': 'product-faqs',
      '#business-contact': 'business-faqs',
      '#business-faqs': 'business-faqs'
    };

    document.querySelectorAll('.zbc-help-card[href^="#"]').forEach(function (card) {
      card.addEventListener('click', function (event) {
        var targetId = categoryMap[card.getAttribute('href')];
        if (!targetId) return;
        var targetGroup = document.getElementById(targetId);
        if (!targetGroup) return;
        event.preventDefault();

        groups.forEach(function (g) {
          var open = g === targetGroup;
          g.classList.toggle('is-open', open);
          if (!open) {
            g.querySelectorAll('.zbc-faq-item').forEach(function (item) {
              item.classList.remove('is-open');
            });
          }
        });

        window.setTimeout(function () {
          targetGroup.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 80);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initZebaeshFaq);
  } else {
    initZebaeshFaq();
  }
  document.addEventListener('shopify:section:load', initZebaeshFaq);
})();



/* =========================================================
   ZEBAESH — OPEN SHOPIFY INBOX LIVE CHAT
========================================================= */

(function () {
  "use strict";

  function deepFindLiveChatButton(root) {
    if (!root) return null;

    const directButton = root.querySelector
      ? root.querySelector(
          'button.activator[aria-label="Live chat"],' +
          'button[part="activator"][aria-label="Live chat"],' +
          '#shopify-element-wrapper button.activator'
        )
      : null;

    if (directButton) {
      return directButton;
    }

    const elements = root.querySelectorAll
      ? root.querySelectorAll("*")
      : [];

    for (const element of elements) {
      if (element.shadowRoot) {
        const shadowButton = deepFindLiveChatButton(
          element.shadowRoot
        );

        if (shadowButton) {
          return shadowButton;
        }
      }

      if (
        element.tagName === "IFRAME" &&
        element.contentDocument
      ) {
        try {
          const iframeButton = deepFindLiveChatButton(
            element.contentDocument
          );

          if (iframeButton) {
            return iframeButton;
          }
        } catch (error) {
          /* Cross-origin iframe — safely ignore */
        }
      }
    }

    return null;
  }

  function triggerRealClick(element) {
    if (!element) return;

    element.dispatchEvent(
      new PointerEvent("pointerdown", {
        bubbles: true,
        composed: true
      })
    );

    element.dispatchEvent(
      new MouseEvent("mousedown", {
        bubbles: true,
        composed: true
      })
    );

    element.dispatchEvent(
      new MouseEvent("mouseup", {
        bubbles: true,
        composed: true
      })
    );

    element.dispatchEvent(
      new MouseEvent("click", {
        bubbles: true,
        composed: true
      })
    );

    if (typeof element.click === "function") {
      element.click();
    }
  }

  function openShopifyInbox() {
    const chatButton = deepFindLiveChatButton(document);

    if (chatButton) {
      triggerRealClick(chatButton);
      return true;
    }

    return false;
  }

  document.addEventListener("click", function (event) {
    const link = event.target.closest(
      ".zbc-open-live-chat"
    );

    if (!link) return;

    event.preventDefault();

    /*
     * Shopify Inbox kabhi lazy-load hota hai,
     * is liye kuch seconds tak retry karte hain.
     */
    let attempts = 0;
    const maxAttempts = 30;

    const timer = window.setInterval(function () {
      attempts += 1;

      if (openShopifyInbox() || attempts >= maxAttempts) {
        window.clearInterval(timer);
      }
    }, 200);
  });
})();